<template>
  <section class="plm-ai-application" :class="themeClass">
    <div class="plm-ai-application__inner">
      <div class="plm-ai-application__copy">
        <span class="plm-ai-application__kicker">PLM + AI应用</span>
        <h2>
          <span>配方研发</span>
          <span>从“试出来”走向“算出来”</span>
        </h2>
        <p>璞华易研PLM内置贝叶斯优化 + AI推荐引擎，让配方研发更加简单高效</p>
        <button type="button" class="plm-ai-application__button" @click="toDetail">
          了解详情
          <el-image :src="linkIcon" alt="" />
        </button>
      </div>

      <div class="plm-ai-application__modules">
        <article
          v-for="item in moduleCards"
          :key="item.id"
          class="plm-ai-application__module"
        >
          <span>{{ item.index }}</span>
          <h3>{{ item.title }}</h3>
          <p>{{ item.description }}</p>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import linkIcon from '@/assets/images/link-to.png'

export default {
  name: 'PLMAIApplication',
  props: {
    theme: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      linkIcon,
      moduleCards: [
        {
          id: 'ai-assistant',
          index: '01',
          title: 'AI助手',
          description: '让研发数据“开口说话”。',
        },
        {
          id: 'bayes',
          index: '02',
          title: 'AI贝叶斯优化',
          description: '让每一次实验都离最优配方更近一步。',
        },
        {
          id: 'formula',
          index: '03',
          title: '配方推荐',
          description: '两大AI引擎，驱动配方智能创新。',
        },
        {
          id: 'spectrum',
          index: '04',
          title: '化学图谱智能分析',
          description: '从谱图到结构，不仅“是什么”，更懂“为什么”。',
        },
      ],
    }
  },
  computed: {
    themeClass() {
      return this.theme ? `plm-ai-application--${this.theme}` : ''
    },
  },
  methods: {
    toDetail() {
      this.$router.push({ name: 'plmAi' })
    },
  },
}
</script>

<style lang="scss" scoped>
.plm-ai-application {
  padding: 9.6rem 0;
  background: #eef3f9;
  border-top: 0.1rem solid #dfe9f5;
  border-bottom: 0.1rem solid #dfe9f5;
}

.plm-ai-application--blue {
  background:
    linear-gradient(135deg, rgba(54, 116, 254, 0.11) 0%, rgba(21, 160, 223, 0.06) 46%, rgba(255, 255, 255, 0.86) 100%),
    #f2f7ff;
  border-top-color: rgba(54, 116, 254, 0.14);
  border-bottom-color: rgba(54, 116, 254, 0.14);
}

.plm-ai-application--white {
  background: #ffffff;
  border-top-color: #ffffff;
  border-bottom-color: #ffffff;
}

.plm-ai-application__inner {
  display: grid;
  grid-template-columns: minmax(34rem, 0.82fr) minmax(0, 1.18fr);
  gap: 4.8rem;
  align-items: center;
  width: 142rem;
  max-width: calc(100% - 8rem);
  margin: 0 auto;
}

.plm-ai-application__copy {
  min-width: 0;

  h2 {
    margin: 1.4rem 0 1.8rem;
    color: #172033;
    font-size: 4.2rem;
    font-weight: 700;
    line-height: 1.34;

    span {
      display: block;
    }

    span + span {
      color: #3674fe;
    }
  }

  p {
    margin: 0 0 3rem;
    color: #293244;
    font-size: 2rem;
    font-weight: 700;
    line-height: 1.75;
  }
}

.plm-ai-application__kicker {
  display: inline-flex;
  align-items: center;
  color: #3674fe;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.4rem;
  letter-spacing: 0;
  text-transform: uppercase;
}

.plm-ai-application__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  min-width: 15.6rem;
  height: 5.2rem;
  padding: 0 2.2rem;
  color: #ffffff;
  font-size: 1.8rem;
  font-weight: 700;
  border: 0.1rem solid #ffffff;
  border-radius: 2.6rem;
  background: linear-gradient(318deg, #0f81f4 0%, #37a4ff 100%);
  box-shadow: 0 1.6rem 3.4rem rgba(54, 116, 254, 0.24);
  cursor: pointer;

  ::v-deep .el-image {
    width: 2.6rem;
    height: 2.6rem;
  }
}

.plm-ai-application__modules {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.4rem;
  align-self: center;
  min-width: 0;
}

.plm-ai-application__module {
  --card-color: #3674fe;
  --card-rgb: 54, 116, 254;
  position: relative;
  overflow: hidden;
  min-height: 13.2rem;
  padding: 2.2rem 2rem 2rem;
  background:
    linear-gradient(115deg, rgba(var(--card-rgb), 0.09) 0%, rgba(255, 255, 255, 0) 54%),
    #ffffff;
  border: 0.1rem solid rgba(var(--card-rgb), 0.18);
  border-radius: 0.6rem;
  box-shadow: 0 1rem 2.4rem rgba(78, 119, 169, 0.08);
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 0.4rem;
    background: linear-gradient(90deg, var(--card-color), rgba(var(--card-rgb), 0.18));
  }

  &::after {
    content: '';
    position: absolute;
    right: 1.8rem;
    top: 2rem;
    width: 3.8rem;
    height: 3.8rem;
    background: rgba(var(--card-rgb), 0.08);
    border-radius: 50%;
    box-shadow: 0 0 0 1rem rgba(var(--card-rgb), 0.04);
  }

  &:nth-child(1) {
    --card-color: #3674fe;
    --card-rgb: 54, 116, 254;
  }

  &:nth-child(2) {
    --card-color: #15a0df;
    --card-rgb: 21, 160, 223;
  }

  &:nth-child(3) {
    --card-color: #19a974;
    --card-rgb: 25, 169, 116;
  }

  &:nth-child(4) {
    --card-color: #7b61ff;
    --card-rgb: 123, 97, 255;
  }

  &:hover {
    transform: translateY(-0.3rem);
    border-color: rgba(var(--card-rgb), 0.36);
    box-shadow: 0 1.6rem 3.2rem rgba(78, 119, 169, 0.14);
  }

  span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 4.8rem;
    height: 4.8rem;
    margin-bottom: 1.2rem;
    color: #ffffff;
    font-family: DINAlternate, Arial, sans-serif;
    font-size: 2.2rem;
    font-weight: 700;
    line-height: 1;
    background: linear-gradient(318deg, var(--card-color) 0%, rgba(var(--card-rgb), 0.68) 100%);
    border-radius: 50%;
    box-shadow: 0 0.8rem 1.8rem rgba(var(--card-rgb), 0.18);
  }

  h3 {
    position: relative;
    z-index: 1;
    margin: 0 0 0.6rem;
    color: #172033;
    font-size: 2rem;
    line-height: 1.4;
  }

  p {
    position: relative;
    z-index: 1;
    margin: 0;
    color: #667085;
    font-size: 1.45rem;
    line-height: 1.62;
  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .plm-ai-application {
    display: none;
  }
}
</style>
